<div class="container">
  <mat-card>
    <form [formGroup]="closeClientForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div class="layout-column">
          <mat-form-field (click)="closureDatePicker.open()">
            <mat-label>{{ 'labels.inputs.Closed On Date' | translate }}</mat-label>
            <input
              matInput
              [min]="minDate"
              [max]="maxDate"
              [matDatepicker]="closureDatePicker"
              required
              formControlName="closureDate"
            />
            <mat-datepicker-toggle matSuffix [for]="closureDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #closureDatePicker></mat-datepicker>
            @if (closeClientForm.controls.closureDate.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Closed On Date' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>

          <mat-form-field class="flex-48">
            <mat-label>{{ 'labels.inputs.Closure Reason' | translate }}</mat-label>
            <mat-select formControlName="closureReasonId">
              @for (reason of closureData; track reason) {
                <mat-option [value]="reason.id">
                  {{ reason.name }}
                </mat-option>
              }
            </mat-select>
            @if (closeClientForm.controls.closureReasonId.hasError('required')) {
              <mat-error>
                {{ 'labels.inputs.Closure Reason' | translate }} {{ 'labels.commons.is' | translate }}
                <strong>{{ 'labels.commons.required' | translate }}</strong>
              </mat-error>
            }
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions class="layout-row align-center gap-5px responsive-column">
        <button type="button" mat-raised-button [routerLink]="['../../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button mat-raised-button color="warn" [disabled]="!closeClientForm.valid">
          {{ 'labels.buttons.Confirm' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
